import { Box } from '@mui/material';
import DateChip from 'src/components/DateChip';

export const FiagroCompetence = ({ competence }: { competence?: string }) => {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <DateChip
        title="Competência"
        date={
          competence && /^\d{2}\/\d{4}$/.test(competence) ? competence : 'N/D'
        }
      />
    </Box>
  );
};
